import { Box, Divider } from "@mui/material";

import { Chat } from "../../../types/chat";

import ChatSearchBar from "./ChatSearchBar";
import ChatFilterTabs from "./ChatFilterTabs";
import ChatSideBarHeader from "./ChatSideBarHeader";
import ChatSideBarChatList from "./ChatSideBarChatList";

const ChatSideBar = ({
  searchValue,
  handleOnSearch,
  chats,
  isChatLoading,
  ownUserId,
  onChatSelect,
  isMobile,
}: {
  searchValue: string;
  handleOnSearch: (value: string) => void;
  chats: Chat[];
  isChatLoading: boolean;
  ownUserId: number;
  onChatSelect?: () => void;
  isMobile?: boolean;
}) => {
  return (
    <Box sx={styles.container}>
      <Box sx={styles.headerSection}>
        <ChatSideBarHeader isChatLoading={isChatLoading} />
        <ChatSearchBar searchValue={searchValue} handleOnSearch={handleOnSearch} isChatLoading={isChatLoading} />
      </Box>
      <Box sx={styles.chatListContainer}>
        <ChatFilterTabs isChatLoading={isChatLoading} />
        <Divider sx={styles.divider} />
        <ChatSideBarChatList
          chats={chats}
          isChatLoading={isChatLoading}
          ownUserId={ownUserId}
          onChatSelect={onChatSelect}
        />
      </Box>
    </Box>
  );
};

export default ChatSideBar;

const styles = {
  container: {
    boxShadow: {
      xs: "0 6px 8px rgba(0, 0, 0, 0.1)", // Shadow from bottom on mobile
      md: "none", // No shadow on desktop
    },

    padding: {
      xs: "20px 0", // Reduced padding on mobile
      md: "30px 0", // Original padding on desktop
    },
    borderInlineEnd: {
      xs: "none", // Remove border on mobile
      md: "1px solid #EAECF0", // Keep border on desktop
    },
    borderBottom: {
      xs: "1px solid #EAECF0", // Add bottom border on mobile for separation
      md: "none", // No bottom border on desktop
    },
    width: {
      xs: "100%", // Full width on mobile
      md: "300px", // Fixed width on desktop
    },
    height: {
      xs: "auto", // Auto height on mobile to fit content
      md: "100%", // Full height on desktop
    },
    maxHeight: {
      xs: "50vh", // Limit sidebar height on mobile to 50% of viewport
      md: "100%", // Full height on desktop
    },
    minHeight: {
      xs: "200px", // Minimum height on mobile
      md: "958px", // Fixed height on desktop
    },
    backgroundColor: {
      xs: "#FAFAFA", // Light background on mobile for better separation
      md: "transparent", // Transparent on desktop
    },
    borderRadius: {
      xs: "8px 8px 0 0", // Rounded top corners on mobile
      md: "0", // No border radius on desktop
    },
    overflow: "hidden", // Prevent content from overflowing
    position: "relative", // Ensure proper positioning
    zIndex: {
      xs: 1, // Ensure sidebar stays above chat container
      md: "auto", // Auto z-index on desktop
    },
    display: "flex",
    flexDirection: "column",
  },
  headerSection: {
    flexShrink: 0, // Prevent header from shrinking
    padding: "0 17px", // Add horizontal padding
  },
  chatListContainer: {
    display: "flex",
    flexDirection: "column",
    gap: "17px",
    px: "17px",
    flex: 1, // Take remaining space
    overflow: "hidden", // Prevent overflow
    minHeight: 0, // Allow flex shrinking
    maxHeight: {
      xs: "calc(50vh - 120px)", // Account for header height on mobile
      md: "none", // No max height on desktop
    },
  },
  divider: {
    mx: "-17px",
  },
};
